import styled from 'styled-components';
import { media } from 'styled-bootstrap-grid';
import { Label } from '@common/components/form/Label';

export const SpaEntityStepWrapper = styled.div`
  label[class^='SliderDateField'] {
    width: 80px;
  }
  scrollbar-gutter: stable;
`;

export const ExperienceWrapper = styled.div`
  width: 100%;
  padding: 30px 20px;
  display: grid;
  justify-content: center;
`;

export const GuestButtonWrapper = styled.div`
  margin-bottom: 20px;
  width: fit-content;
  button {
    width: 100%;
    padding: 15px;
  }
`;

export const GuestName = styled.div`
  margin-bottom: 20px;
`;

export const ExperienceTitleWrapper = styled.div`
  width: 100%;
  margin-top: -30px;
  padding: 0 20px;
  justify-self: center;
  justify-content: center;
  max-width: 100%;
  ${media.md`
    padding: 0;
  `}
`;

export const SpaEntitySelectionWrapper = styled.div`
  border: none;
  position: relative;
  display: grid;
  grid-template-columns: 1fr;

  ${media.md`
    padding:  1.5rem;
    border: 1px solid #efefef;
    border-radius: 3px;
    margin-top: 20px;
    grid-template-columns: 1fr;
  `};
`;

export const SpaAvailabilityWrapper = styled.div`
  padding: 0;
  display: grid;
  grid-template-columns: 1fr;
  align-items: center;
  gap: 10px;
  margin-bottom: 1rem;
  width: 100%;
  @media screen and (max-width: 850px) {
    border: ${({ theme }) => `1px solid ${theme.defaultColors.lightGrey}`};
    padding: 1rem;
    border-radius: 3px;
  }
`;

export const SubtitleWrapper = styled.div`
  color: ${({ theme }) => theme.defaultColors.grey};
`;

export const TitleWrapper = styled.div`
  display: grid;
  height: fit-content;
  width: 100%;
  grid-template-columns: auto auto;
  justify-content: space-between;
  gap: 0.5rem;
  white-space: nowrap;
  align-items: center;
  margin-bottom: 1rem;
`;

export const DividerLine = styled.div`
  height: 1px;
  width: 100%;
  border-top: 1px solid ${({ theme }) => theme.defaultColors.lightGrey};
  grid-column: 1 / 3;
  margin-bottom: 10px;
`;

export const DropdownGridWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr;

  @media (min-width: 600px) {
    grid-template-columns: 1fr;
  }
`;

export const DropdownWrapper = styled.div`
  width: 100%;
  ${media.md`
    width: 50%;
  `}
`;

export const SpaLabel = styled(Label)`
  margin: 0;
`;

export const ToggleWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;

  @media screen and (max-width: 850px) {
    justify-content: flex-start;
    padding: 1rem 0;
  }
`;
